import { Venues } from "../../types/interfaceType";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchVenuesList,getVendorRegisterVenues,getVenuePricingRule,getTrendingSports, fetchVenuesDetails,getSlotsByDate, getCategories,getUsersRecommendedVenues, getNearbyTurfs ,filterVenues,validateDirectBookingLink,getDirectBookingLinkVenueSlotsByDate,checkVenueAvailability,getTrendingVenues, searchLocation} from "../thunkMidddleware/venueMiddleware";
import { toast } from "@/components/ui/sonner";

import BaseApiState, { createBaseAPi } from "@/api/BaseApiState"
import { setLocation } from "../slices/global.Slice"
import Strings from "@/constants/String";

 interface Filters{
    priceRange?: [number, number],
    page?: number,
    limit?:number,
    city?:string,
    sortBy?:string
    sportsCategory?:string[]
}
const MAX = 5000;
const MIN = 100;

interface InitialStateType{
    getTrendingSportsResponse:createBaseAPi,
    getVenuePricingRuleResponse:createBaseAPi,
    venuesList: createBaseAPi,
    venueDetail: createBaseAPi,
    Categories: createBaseAPi,
    selectedCategories: string[],
    nearbyTurfs: createBaseAPi,
    filterVenuesResponse:createBaseAPi,

    filters: Filters,
    getSlotsByDateResponse:createBaseAPi,
    validateDirectBookingLinkResponse:createBaseAPi,
    getDirectBookingLinkVenueSlotsByDateResponse:createBaseAPi,
    checkVenueAvailabilityResponse:createBaseAPi,
    getTrendingVenuesResponse:createBaseAPi,
    searchLocationResponse:createBaseAPi,
    showNoVenueScreen:Boolean,
    getUsersRecommendedVenuesResponse:createBaseAPi,

 
}

const initialState :InitialStateType= {
    getTrendingSportsResponse:BaseApiState,
    getVenuePricingRuleResponse:BaseApiState,
    getUsersRecommendedVenuesResponse:BaseApiState,
    showNoVenueScreen:false,
    checkVenueAvailabilityResponse:BaseApiState,
    getTrendingVenuesResponse:BaseApiState,
    searchLocationResponse:BaseApiState,
    venuesList: BaseApiState,
    venueDetail: BaseApiState,
    Categories: BaseApiState,
    selectedCategories: [],
    nearbyTurfs: BaseApiState,
    filterVenuesResponse:BaseApiState,
    getSlotsByDateResponse:BaseApiState,
    validateDirectBookingLinkResponse:BaseApiState,
    getDirectBookingLinkVenueSlotsByDateResponse:BaseApiState,
    filters: {
        priceRange: [MIN, MAX],
        page: 1,
        limit: Strings.venueitemPerpage,
        sportsCategory:[],
        sortBy:"featured",
    }

};


const venuesSlice = createSlice({
    name: "venues",
    initialState,
    reducers: {
        filterUsers: (state, action) => {

        },
        resetVenueDetails: (state) => {
            state.venueDetail = BaseApiState;
        },
        resetLocationSuggestions: (state) => {
            state.searchLocationResponse = BaseApiState;
        },
        setSelectedCategories: (state, action) => {
            state.selectedCategories = action.payload
            state.filters={
                ...state.filters,
                sportsCategory:action.payload
            }
        },

        setPriceRange: (state, action) => {
            const  {payload} =action
            state.filters = {
                ...state.filters,
                priceRange:payload
            }
        },

        setSortBy: (state, action) => {
            const  {payload} =action
            state.filters = {
                ...state.filters,
                sortBy:payload
            }
        },
        resetSortBy: (state) => {
            state.filters = {
                ...state.filters,
                sortBy:"Featured",
            }
        },


        resetPriceRange: (state) => {
            state.filters.priceRange = [MIN, MAX]
        },

        setFilters: (state, action: PayloadAction<{  field: string, value: string | {} | boolean | number | [] }>) => {
            const  {field,value} =action.payload

            state.filters = {
                ...state.filters,
                [field]:value
            }
        },
        resetFilters:(state)=>{
            state.filters = {
                priceRange: [MIN, MAX],
                page: 1,
                limit: Strings.venueitemPerpage,
                city:null,
                sportsCategory:[]
            }
        }

    },
    extraReducers: (builder) => {
        // builder
        //     .addCase(fetchVenuesList.pending, (state) => {
        //         state.venuesList.isLoading = true;
        //         state.venuesList.error = null;
        //     })
        //     .addCase(fetchVenuesList.fulfilled, (state, action) => {
        //         state.venuesList.isLoading = false;
        //         state.venuesList.success = action.payload?.success,
        //             state.venuesList.payload = action.payload?.payload;
        //             if(action.payload?.payload?.hasVenues === false){
        //                 state.showNoVenueScreen = true
        //                 toast.error(`${action?.payload?.message}`, { closeButton: true });
        //             }else{
        //                 state.showNoVenueScreen = false
        //             }
        //     })
        //     .addCase(fetchVenuesList.rejected, (state, action) => {
        //         state.venuesList.isLoading = false;
        //         state.venuesList.error = action.error as string;
        //         state.venuesList.payload = null
        //     });
              // ----------------------------------------------------

    // ----------------------------------------------------


        builder
        .addCase(getTrendingSports.pending, (state) => {
            state.getTrendingSportsResponse.isLoading = true;
            state.getTrendingSportsResponse.error = null;
        })
        .addCase(getTrendingSports.fulfilled, (state, action) => {
            state.getTrendingSportsResponse.isLoading = false;
            state.getTrendingSportsResponse.success = action.payload?.success;
                state.getTrendingSportsResponse.payload = action.payload?.payload;
        })
        .addCase(getTrendingSports.rejected, (state, action:any) => {
            state.getTrendingSportsResponse.isLoading = false;
            state.getTrendingSportsResponse.error = action.payload?.error ||action.payload?.message ;
        });

        // ----------------------------------------------------

              builder
              .addCase(fetchVenuesList.pending, (state,action: any) => {  
                  const page = action.meta.arg?.payload?.page || 1;
                  if (page === 1) {
                      state.venuesList.isLoading = true; // full loader only on first page
                  }
                  state.venuesList.error = null;
              })
           
              .addCase(fetchVenuesList.fulfilled, (state, action: any) => {
                  state.venuesList.isLoading = false;
                  state.venuesList.success = action.payload?.success;
                  state.venuesList.error = null;
              
                  const newPayload = action.payload?.payload;
                  const page = action.meta.arg?.payload?.page || 1;
                  if (page === 1 || !state.venuesList.payload) {
                      // ✅ First page OR reset → replace
                      state.venuesList.payload = newPayload;
                  } else {
                      // ✅ Next pages → append
                      state.venuesList.payload = {
                          ...newPayload,
                          turfs: [
                              ...(state.venuesList.payload?.turfs || []),
                              ...(newPayload?.turfs || [])
                          ]
                      };
                  }
              })
  
              .addCase(fetchVenuesList.rejected, (state, action:any) => {
                  state.venuesList.isLoading = false;
                  state.venuesList.error = action.payload?.error ||action.payload?.message ;
                  state.venuesList.payload = null
                  state.venuesList.success = false
              });

         builder
            .addCase(getVendorRegisterVenues.pending, (state) => {
                state.venuesList.isLoading = true;
                state.venuesList.error = null;
            })
            .addCase(getVendorRegisterVenues.fulfilled, (state, action) => {
                state.venuesList.isLoading = false;
                state.venuesList.success = action.payload?.success
                state.venuesList.payload = action.payload?.payload;
            })
            .addCase(getVendorRegisterVenues.rejected, (state, action) => {
                state.venuesList.isLoading = false;
                state.venuesList.error = action.error as string;
                state.venuesList.payload = null
            });
              // ----------------------------------------------------
        builder
            .addCase(fetchVenuesDetails.pending, (state) => {
                state.venueDetail.isLoading = true;
                state.venueDetail.error = null;
            })
            .addCase(fetchVenuesDetails.fulfilled, (state, action) => {
                state.venueDetail.isLoading = false;
                state.venueDetail.success = action.payload?.success,
                    state.venueDetail.payload = action.payload?.payload;
            })
            .addCase(fetchVenuesDetails.rejected, (state, action) => {
                state.venueDetail.isLoading = false;
                state.venueDetail.error = action.error as string;
            });

        builder
            .addCase(getCategories.pending, (state) => {
                state.Categories.isLoading = true;
                state.Categories.error = null;
            })
            .addCase(getCategories.fulfilled, (state, action) => {
                state.Categories.isLoading = false;
                state.Categories.success = action.payload?.success;
                state.Categories.payload = action.payload?.payload;
            })
            .addCase(getCategories.rejected, (state, action) => {
                state.Categories.isLoading = false;
                state.Categories.error = action.error as string;
            });
        // ----------------------------------------------------

        builder
            .addCase(getNearbyTurfs.pending, (state) => {
                state.nearbyTurfs.isLoading = true;
                state.nearbyTurfs.error = null;
            })
            .addCase(getNearbyTurfs.fulfilled, (state, action) => {
                state.nearbyTurfs.isLoading = false;
                state.nearbyTurfs.success = action.payload?.success;
                state.nearbyTurfs.payload = action.payload?.payload;
                state.venuesList.payload = {
                    turfs: action.payload?.payload?.nearbyVenues
                }

                if(action.payload?.payload?.hasVenues === false){
                    state.showNoVenueScreen = true
                    if (action?.payload?.message) {
                        toast.error(action.payload.message, { closeButton: true });
                    }
                }else{
                    state.showNoVenueScreen = false
                }
            })
            .addCase(getNearbyTurfs.rejected, (state, action) => {
                state.nearbyTurfs.isLoading = false;
                state.nearbyTurfs.error = action.error as string;
            });


               // ----------------------------------------------------

        builder
        .addCase(filterVenues.pending, (state) => {
            state.filterVenuesResponse.isLoading = true;
            state.filterVenuesResponse.error = null;
        })
        .addCase(filterVenues.fulfilled, (state, action) => {
            state.filterVenuesResponse.isLoading = false;
            state.filterVenuesResponse.success = action.payload?.success;
            state.filterVenuesResponse.payload = action.payload?.payload;
        })
        .addCase(filterVenues.rejected, (state, action) => {
            state.filterVenuesResponse.isLoading = false;
            state.filterVenuesResponse.error = action.error as string;
        });
          // ----------------------------------------------------

          // ------------------------------------------------------------------------------------------
        builder
        .addCase(getSlotsByDate.pending, (state) => {
            state.getSlotsByDateResponse.isLoading = true;
            state.getSlotsByDateResponse.error = null;
        })
        .addCase(getSlotsByDate.fulfilled, (state, action) => {
            state.getSlotsByDateResponse.isLoading = false
            state.getSlotsByDateResponse.success = action.payload?.success
            state.getSlotsByDateResponse.payload = action.payload?.payload;
        })
        .addCase(getSlotsByDate.rejected, (state, action:any) => {
            state.getSlotsByDateResponse.isLoading = false;
            state.getSlotsByDateResponse.error = action.payload?.error ||action.payload?.message ;
            state.getSlotsByDateResponse.payload = null
        });

           // ------------------------------------------------------------------------------------------
           builder
           .addCase(validateDirectBookingLink.pending, (state) => {
               state.validateDirectBookingLinkResponse.isLoading = true;
               state.validateDirectBookingLinkResponse.error = null;
           })
           .addCase(validateDirectBookingLink.fulfilled, (state, action) => {
               state.validateDirectBookingLinkResponse.isLoading = false
               state.validateDirectBookingLinkResponse.success = action.payload?.success
               state.validateDirectBookingLinkResponse.payload = action.payload?.payload;
               if( action.payload?.payload?.venueDetails){
                state.venueDetail.payload = action.payload?.payload?.venueDetails
               }
           })
           .addCase(validateDirectBookingLink.rejected, (state, action:any) => {
               state.validateDirectBookingLinkResponse.isLoading = false;
               state.validateDirectBookingLinkResponse.error = action.payload?.error ||action.payload?.message ;
               state.validateDirectBookingLinkResponse.payload = null
           });
   
            // ------------------------------------------------------------------------------------------
            builder
            .addCase(getDirectBookingLinkVenueSlotsByDate.pending, (state) => {
                state.getDirectBookingLinkVenueSlotsByDateResponse.isLoading = true;
                state.getDirectBookingLinkVenueSlotsByDateResponse.error = null;
            })
            .addCase(getDirectBookingLinkVenueSlotsByDate.fulfilled, (state, action) => {
                state.getDirectBookingLinkVenueSlotsByDateResponse.isLoading = false
                state.getDirectBookingLinkVenueSlotsByDateResponse.success = action.payload?.success
                state.getDirectBookingLinkVenueSlotsByDateResponse.payload = action.payload?.payload;
               
            })
            .addCase(getDirectBookingLinkVenueSlotsByDate.rejected, (state, action:any) => {
                state.getDirectBookingLinkVenueSlotsByDateResponse.isLoading = false;
                state.getDirectBookingLinkVenueSlotsByDateResponse.error = action.payload?.error ||action.payload?.message ;
                state.getDirectBookingLinkVenueSlotsByDateResponse.payload = null
            });

     // ------------------------------------------------------------------------------------------
     builder
     .addCase(checkVenueAvailability.pending, (state) => {
         state.checkVenueAvailabilityResponse.isLoading = true;
         state.checkVenueAvailabilityResponse.error = null;
     })
     .addCase(checkVenueAvailability.fulfilled, (state, action) => {
         state.checkVenueAvailabilityResponse.isLoading = false
         state.checkVenueAvailabilityResponse.success = action.payload?.success
         state.checkVenueAvailabilityResponse.payload = action.payload?.payload;
        
     })
     .addCase(checkVenueAvailability.rejected, (state, action:any) => {
         state.checkVenueAvailabilityResponse.isLoading = false;
         state.checkVenueAvailabilityResponse.error = action.payload?.error ||action.payload?.message ;
         state.checkVenueAvailabilityResponse.payload = null
     });

        // ------------------------------------------------------------
           // ------------------------------------------------------------------------------------------
     builder
     .addCase(searchLocation.pending, (state) => {
         state.searchLocationResponse.isLoading = true;
         state.searchLocationResponse.error = null;
     })
     .addCase(searchLocation.fulfilled, (state, action) => {
         state.searchLocationResponse.isLoading = false;
         state.searchLocationResponse.success = action.payload?.success;
         state.searchLocationResponse.payload = action.payload?.payload;
     })
     .addCase(searchLocation.rejected, (state, action:any) => {
         // A superseded keystroke aborts the in-flight request. That is not a
         // failure and must not blank the list — otherwise the suggestions
         // flicker away between every character typed.
         if (action.meta?.aborted) return;

         state.searchLocationResponse.isLoading = false;
         state.searchLocationResponse.error = action.payload?.error || action.payload?.message;
         state.searchLocationResponse.payload = null;
     });

     builder
     .addCase(getTrendingVenues.pending, (state) => {
         state.getTrendingVenuesResponse.isLoading = true;
         state.getTrendingVenuesResponse.error = null;
     })
     .addCase(getTrendingVenues.fulfilled, (state, action) => {
         state.getTrendingVenuesResponse.isLoading = false
         state.getTrendingVenuesResponse.success = action.payload?.success
         state.getTrendingVenuesResponse.payload = action.payload?.payload;
        
     })
     .addCase(getTrendingVenues.rejected, (state, action:any) => {
         state.getTrendingVenuesResponse.isLoading = false;
         state.getTrendingVenuesResponse.error = action.payload?.error ||action.payload?.message ;
         state.getTrendingVenuesResponse.payload = null
     });

        // ------------------------------------------------------------


        builder
        .addCase(getUsersRecommendedVenues.pending, (state) => {
            state.getUsersRecommendedVenuesResponse.isLoading = true;
            state.getUsersRecommendedVenuesResponse.error = null;
        })
        .addCase(getUsersRecommendedVenues.fulfilled, (state, action) => {
            state.getUsersRecommendedVenuesResponse.isLoading = false;
            state.getUsersRecommendedVenuesResponse.success = action.payload?.success;
            state.getUsersRecommendedVenuesResponse.payload = action.payload?.payload;
            state.getUsersRecommendedVenuesResponse.error = null
            // An empty city is not an error state: the recommendation rail simply
            // hides itself (Dashboard reads `hasVenues`). It must not take the whole
            // app over via `showNoVenueScreen`, and it must not toast — the API
            // sends `message: null` here, which surfaced as a red "null" on load.
            state.showNoVenueScreen = false
        })
        .addCase(getUsersRecommendedVenues.rejected, (state, action) => {
            state.getUsersRecommendedVenuesResponse.isLoading = false;
            state.getUsersRecommendedVenuesResponse.error = action?.payload || action?.error;
            state.getUsersRecommendedVenuesResponse.success = false
            state.getUsersRecommendedVenuesResponse.payload = null
        });


        // ------------------------------------------------------------


        builder
        .addCase(getVenuePricingRule.pending, (state) => {
            state.getVenuePricingRuleResponse.isLoading = true;
            state.getVenuePricingRuleResponse.error = null;
        })
        .addCase(getVenuePricingRule.fulfilled, (state, action) => {
            state.getVenuePricingRuleResponse.isLoading = false;
            state.getVenuePricingRuleResponse.success = action.payload?.success;
            state.getVenuePricingRuleResponse.payload = action.payload?.payload;
            state.getVenuePricingRuleResponse.error = null
         
        })
        .addCase(getVenuePricingRule.rejected, (state, action) => {
            state.getVenuePricingRuleResponse.isLoading = false;
            state.getVenuePricingRuleResponse.error = action?.payload || action?.error;
            state.getVenuePricingRuleResponse.success = false
            state.getVenuePricingRuleResponse.payload = null
        });



        // .addCase(setLocation, (state, action) => {
        //     // state
        // });
    }



});


export const {setFilters,resetVenueDetails,resetLocationSuggestions,resetFilters, filterUsers,setSortBy,resetSortBy, setPriceRange, resetPriceRange, setSelectedCategories } = venuesSlice.actions;

export default venuesSlice.reducer;